// extracted by mini-css-extract-plugin
module.exports = {"stickyTableCell":"azrAE2Kh","stickyTableCellBorder":"jmGPbJIe"};